"use client";

import Link from "next/link";
import { play } from "cuelume";
import Icon from "@/components/Icon";
import type { Locale } from "@/lib/i18n";
import { toLocalizedPath } from "@/lib/i18n";

export default function RandomTestLink({ locale }: { locale: Locale }) {
  return (
    <Link
      href={toLocalizedPath("/random-test", locale)}
      onClick={() => play("press")}
      className="btn-primary inline-flex min-h-11 items-center justify-center gap-2"
      prefetch={false}
    >
      <Icon name="dice-5" size={17} />
      {locale === "ko" ? "랜덤 테스트 뽑기" : "Pick a random quiz"}
    </Link>
  );
}
